import script from "./headerCommons.vue?vue&type=script&lang=js"
export * from "./headerCommons.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__